"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _moment = _interopRequireDefault(require("moment"));
var _i18next = _interopRequireDefault(require("i18next"));
var _reactI18next = require("react-i18next");
var _constants = require("../../utils/constants");
var _pickers = require("@material-ui/pickers");
var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _formik = require("formik");
var _CircularLoader = _interopRequireDefault(require("../CircularLoader"));
var _DateTimePicker = _interopRequireDefault(require("../DateTimePicker"));
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _Switch = _interopRequireDefault(require("../Switch"));
var _Button = _interopRequireDefault(require("../Button"));
var _Textarea = _interopRequireDefault(require("./Textarea"));
var _excluded = ["className"],
  _excluded2 = ["name"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var INITIAL_VALUES = {
  enable: false,
  enableAutoReply: false,
  replyMessage: _i18next["default"].t('inboxBreak.manual.setup.defaultMessage'),
  days: new Array(7).fill(false),
  startTime: 0,
  endTime: 0,
  timezone: ''
};
var View = function View(_ref) {
  var open = _ref.open,
    isEdit = _ref.isEdit,
    onClose = _ref.onClose,
    onSubmit = _ref.onSubmit,
    onRemove = _ref.onRemove,
    isLoading = _ref.isLoading,
    messageMaxLength = _ref.messageMaxLength,
    _ref$initialValues = _ref.initialValues,
    initialValues = _ref$initialValues === void 0 ? INITIAL_VALUES : _ref$initialValues;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var title = (0, _react.useMemo)(function () {
    return isEdit ? t('inboxBreak.scheduledBreak.form.edit') : t('inboxBreak.scheduledBreak.form.create');
  }, [isEdit]);
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    fullWidth: true,
    maxWidth: "sm",
    open: open,
    onClose: onClose
  }, /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    initialValues: initialValues,
    onSubmit: onSubmit,
    validate: function validate(values) {
      var err = {};
      if (values.days.every(function (each) {
        return !each;
      })) {
        err.days = true;
      }

      // Start time should force to be less than end time
      if (values.startTime >= values.endTime) {
        err.endTime = t('inboxBreak.scheduledBreak.form.endTime.invalid');
      }
      return err;
    }
  }, function (_ref2) {
    var isValid = _ref2.isValid;
    return /*#__PURE__*/_react["default"].createElement(_formik.Form, {
      className: "p-6"
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h1", {
      className: "text-3xl font-bold"
    }, title), /*#__PURE__*/_react["default"].createElement(ToggleField, null), /*#__PURE__*/_react["default"].createElement(DaysSelectField, null), /*#__PURE__*/_react["default"].createElement(TimeRangeField, null), /*#__PURE__*/_react["default"].createElement(AutoReplyField, {
      messageMaxLength: messageMaxLength
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "mt-16"
    }, isEdit && /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      onClick: onRemove,
      className: "text-lg text-red font-semibold"
    }, t('inboxBreak.scheduledBreak.form.remove')), /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex mt-4"
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      type: "button",
      color: "secondary",
      onClick: onClose,
      disabled: isLoading,
      className: "w-40 mr-2"
    }, t('button.cancel')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      type: "submit",
      className: "w-40 ml-2",
      disabled: !isValid || isLoading
    }, isLoading ? /*#__PURE__*/_react["default"].createElement(_CircularLoader["default"], {
      size: 24,
      color: "inherit"
    }) : t('button.save')))));
  }));
};
var ToggleField = function ToggleField() {
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center justify-between my-6"
  }, /*#__PURE__*/_react["default"].createElement(Title, {
    className: "flex-1"
  }, t('inboxBreak.scheduledBreak.form.toggle')), /*#__PURE__*/_react["default"].createElement(_Switch["default"], {
    field: true,
    size: "sm",
    name: "enable"
  }));
};
var DaysSelectField = (0, _formik.connect)(function (_ref3) {
  var formik = _ref3.formik;
  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation3.t;
  var selectedDays = formik.values.days;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "my-6"
  }, /*#__PURE__*/_react["default"].createElement(Title, null, t('inboxBreak.scheduledBreak.form.days')), /*#__PURE__*/_react["default"].createElement(_formik.FieldArray, {
    name: "days",
    render: function render(arrayHelpers) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "my-4"
      }, _constants.SCHEDULE_DAYS.map(function (day, index) {
        return /*#__PURE__*/_react["default"].createElement("button", {
          key: "".concat(day, "-").concat(index),
          type: "button",
          className: (0, _classnames["default"])('font-bold rounded-full p-2 w-10 h-10 mr-4 last:mr-0', {
            'text-primary bg-secondary': !selectedDays[index],
            'text-white bg-primary': selectedDays[index]
          }),
          onClick: function onClick() {
            return arrayHelpers.replace(index, !selectedDays[index]);
          }
        }, day);
      }));
    }
  }));
});
var TimeRangeField = (0, _formik.connect)(function (_ref4) {
  var formik = _ref4.formik;
  var _useTranslation4 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation4.t;
  var _formik$values = formik.values,
    startTime = _formik$values.startTime,
    endTime = _formik$values.endTime;
  (0, _react.useEffect)(function () {
    if (!startTime) {
      formik.setFieldValue('startTime', (0, _moment["default"])().unix());
      return;
    }
    if (endTime <= startTime) {
      var start = _moment["default"].unix(startTime);
      var nextEndTime = start.clone().add(1, 'h');
      if (nextEndTime.clone().startOf('day').diff(start.clone().startOf('day'), 'day') > 0) {
        nextEndTime = start.clone().endOf('day');
      }
      formik.setFieldValue('endTime', nextEndTime.unix());
    }
  }, [startTime]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex my-4"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 mr-2"
  }, /*#__PURE__*/_react["default"].createElement(Title, null, t('inboxBreak.scheduledBreak.form.start')), /*#__PURE__*/_react["default"].createElement(TimePickerField, {
    name: "startTime"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 ml-2"
  }, /*#__PURE__*/_react["default"].createElement(Title, null, t('inboxBreak.scheduledBreak.form.end')), /*#__PURE__*/_react["default"].createElement(TimePickerField, {
    name: "endTime",
    invalid: endTime < startTime
  })));
});
var AutoReplyField = function AutoReplyField(_ref5) {
  var messageMaxLength = _ref5.messageMaxLength;
  var _useTranslation5 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation5.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "my-4"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
    control: /*#__PURE__*/_react["default"].createElement(_formik.Field, {
      name: "enableAutoReply",
      render: function render(_ref6) {
        var field = _ref6.field,
          form = _ref6.form;
        return /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
          size: "small",
          name: field.name,
          checked: field.value,
          onChange: function onChange(e) {
            return form.setFieldValue(field.name, !field.value);
          }
        });
      }
    }),
    label: /*#__PURE__*/_react["default"].createElement(Title, null, t('inboxBreak.scheduledBreak.form.autoReply'))
  })), /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "replyMessage",
    render: function render(_ref7) {
      var field = _ref7.field,
        form = _ref7.form;
      return /*#__PURE__*/_react["default"].createElement(_Textarea["default"], {
        value: field.value,
        maxLength: messageMaxLength,
        onKeyPress: function onKeyPress(e) {
          return e.stopPropagation();
        },
        onChange: function onChange(e) {
          return form.setFieldValue(field.name, e.target.value);
        }
      });
    }
  }));
};
var Title = function Title(_ref8) {
  var className = _ref8.className,
    props = (0, _objectWithoutProperties2["default"])(_ref8, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
    className: (0, _classnames["default"])('text-lg text-dark font-bold my-2', className)
  }));
};
var FORMAT = 'h:mma';
var TimePickerField = function TimePickerField(_ref9) {
  var name = _ref9.name,
    props = (0, _objectWithoutProperties2["default"])(_ref9, _excluded2);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative"
  }, /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: name,
    render: function render(_ref10) {
      var field = _ref10.field,
        form = _ref10.form;
      var value = field.value ? _moment["default"].unix(field.value) : (0, _moment["default"])();
      var error = form.errors[field.name];
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('flex items-center justify-between w-full px-4 py-2 border rounded text-medium', {
          'border-red': !!error
        })
      }, /*#__PURE__*/_react["default"].createElement("div", null, value.format(FORMAT)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "opacity-0 absolute inset-0 z-10"
      }, /*#__PURE__*/_react["default"].createElement(_DateTimePicker["default"], (0, _extends2["default"])({
        autoOk: true,
        field: false,
        variant: "inline",
        className: "w-full h-full",
        value: value,
        format: FORMAT,
        name: field.name,
        picker: _pickers.TimePicker,
        PopoverProps: {
          elevation: 1
        },
        onChange: function onChange(value) {
          form.setFieldValue(name, value.unix());
        }
      }, props)))), /*#__PURE__*/_react["default"].createElement("p", {
        className: "text-red text-xs h-6 leading-loose"
      }, error));
    }
  }));
};
var _default = exports["default"] = View;
//# sourceMappingURL=ScheduledBreakForm.js.map